/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DiscordRelayResponse
 */
export interface DiscordRelayResponse {
    /**
     * 
     * @type {boolean}
     * @memberof DiscordRelayResponse
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscordRelayResponse
     */
    message: string;
}

/**
 * Check if a given object implements the DiscordRelayResponse interface.
 */
export function instanceOfDiscordRelayResponse(value: object): value is DiscordRelayResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function DiscordRelayResponseFromJSON(json: any): DiscordRelayResponse {
    return DiscordRelayResponseFromJSONTyped(json, false);
}

export function DiscordRelayResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscordRelayResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'message': json['message'],
    };
}

export function DiscordRelayResponseToJSON(json: any): DiscordRelayResponse {
    return DiscordRelayResponseToJSONTyped(json, false);
}

export function DiscordRelayResponseToJSONTyped(value?: DiscordRelayResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
    };
}

